import React from 'react';
import { motion } from 'framer-motion';
import { Download, Headphones, FileText, ImagePlus, RefreshCw, Clock, Mic, Camera, MessageSquare, HelpCircle } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <Download className="w-6 h-6 text-gray-700" data-id="element-294" />,
    text: 'Descargar fotos del teléfono al computador'
  }, {
    icon: <Headphones className="w-6 h-6 text-gray-700" data-id="element-295" />,
    text: 'Escuchar y transcribir audios de terreno'
  }, {
    icon: <FileText className="w-6 h-6 text-gray-700" data-id="element-296" />,
    text: 'Escribir el informe desde cero'
  }, {
    icon: <ImagePlus className="w-6 h-6 text-gray-700" data-id="element-297" />,
    text: 'Insertar fotos manualmente en el documento'
  }, {
    icon: <RefreshCw className="w-6 h-6 text-gray-700" data-id="element-298" />,
    text: 'Repetir todo en la próxima visita'
  }];
  return <section id="problema" className="py-16 sm:py-24 bg-gray-50 overflow-hidden" data-id="element-299">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-300">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center" data-id="element-301">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5
        }} className="mb-12 lg:mb-0" data-id="element-302">
            <h2 className="text-sm font-semibold text-blue-600 tracking-wide uppercase mb-2" data-id="element-303">
              El problema
            </h2>
            <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-6 sm:mb-8" data-id="element-304">
              2 horas perdidas. Después de cada visita.
            </h3>

            <ul className="space-y-4 sm:space-y-6 mb-8 sm:mb-10" data-id="element-305">
              {problems.map((problem, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start" data-id="element-306">
                  <div className="flex-shrink-0 h-9 w-9 sm:h-10 sm:w-10 rounded-lg bg-white border border-gray-200 flex items-center justify-center shadow-sm" data-id="element-307">
                    {problem.icon}
                  </div>
                  <p className="ml-3 sm:ml-4 text-base sm:text-lg text-gray-700 mt-1 sm:mt-1.5 font-medium" data-id="element-308">
                    {problem.text}
                  </p>
                </motion.li>)}
            </ul>

            <div className="inline-block bg-blue-50 border border-blue-100 rounded-lg px-4 sm:px-6 py-3 sm:py-4" data-id="element-309">
              <p className="text-lg sm:text-xl font-bold text-blue-900" data-id="element-310">
                Multiplica eso por cada obra, cada semana.
              </p>
            </div>

            <div className="mt-3 sm:mt-4 bg-red-50 border border-red-100 rounded-lg px-4 sm:px-6 py-3 sm:py-4" data-id="element-311">
              <p className="text-lg sm:text-xl font-bold text-red-800" data-id="element-312">
                Tiempo que debería estar en terreno.
              </p>
            </div>
          </motion.div>

          {/* Chaos Illustration - Datos sin destino */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative h-[320px] sm:h-[420px] w-full bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden flex flex-col" data-id="element-313">
            {/* Subtle dot grid background pattern */}
            <div className="absolute inset-0 opacity-40" style={{
            backgroundImage: 'radial-gradient(#e5e7eb 1px, transparent 1px)',
            backgroundSize: '20px 20px'
          }} data-id="element-314" />

            {/* Top Label */}
            <div className="absolute top-4 left-1/2 -translate-x-1/2 z-30" data-id="element-315">
              <div className="bg-red-50 text-red-600 text-[10px] sm:text-xs font-semibold px-3 py-1 rounded-full border border-red-100 shadow-sm whitespace-nowrap" data-id="element-316">
                Datos dispersos, sin destino
              </div>
            </div>

            {/* Connecting Arrows (SVG) — more arrows, more disordered */}
            <svg className="absolute inset-0 w-full h-full pointer-events-none z-0" data-id="element-317">
              <defs data-id="element-318">
                <marker id="arrowhead" markerWidth="6" markerHeight="4" refX="5" refY="2" orient="auto" data-id="element-319">
                  <polygon points="0 0, 6 2, 0 4" fill="#d1d5db" data-id="element-320" />
                </marker>
                <marker id="arrowhead-red" markerWidth="6" markerHeight="4" refX="5" refY="2" orient="auto" data-id="element-321">
                  <polygon points="0 0, 6 2, 0 4" fill="#fca5a5" data-id="element-322" />
                </marker>
              </defs>
              {/* Top Left to Center */}
              <path d="M 85 105 Q 125 145 165 175" stroke="#d1d5db" strokeWidth="1.5" fill="none" strokeDasharray="4 4" markerEnd="url(#arrowhead)" data-id="element-323" />
              {/* Top Right to Center */}
              <path d="M 285 105 Q 245 145 205 175" stroke="#d1d5db" strokeWidth="1.5" fill="none" strokeDasharray="4 4" markerEnd="url(#arrowhead)" data-id="element-324" />
              {/* Bottom Left to Center */}
              <path d="M 85 305 Q 125 255 165 225" stroke="#d1d5db" strokeWidth="1.5" fill="none" strokeDasharray="4 4" markerEnd="url(#arrowhead)" data-id="element-325" />
              {/* Bottom Right to Center */}
              <path d="M 285 305 Q 245 255 205 225" stroke="#d1d5db" strokeWidth="1.5" fill="none" strokeDasharray="4 4" markerEnd="url(#arrowhead)" data-id="element-326" />
              {/* Extra arrow: Top center swooping down */}
              <path d="M 180 70 Q 160 120 175 170" stroke="#fca5a5" strokeWidth="1" fill="none" strokeDasharray="3 3" markerEnd="url(#arrowhead-red)" data-id="element-327" />
              {/* Extra arrow: Left side curving in */}
              <path d="M 40 200 Q 80 190 150 195" stroke="#d1d5db" strokeWidth="1" fill="none" strokeDasharray="3 3" markerEnd="url(#arrowhead)" data-id="element-328" />
              {/* Extra arrow: Right side curving in */}
              <path d="M 330 180 Q 280 195 215 200" stroke="#d1d5db" strokeWidth="1" fill="none" strokeDasharray="3 3" markerEnd="url(#arrowhead)" data-id="element-329" />
              {/* Background arrows — right side, more disorder */}
              <path d="M 320 60 Q 300 110 310 160" stroke="#e5e7eb" strokeWidth="1" fill="none" strokeDasharray="3 4" markerEnd="url(#arrowhead)" data-id="element-330" />
              <path d="M 350 130 Q 310 150 290 200" stroke="#e5e7eb" strokeWidth="1" fill="none" strokeDasharray="4 3" markerEnd="url(#arrowhead)" data-id="element-331" />
              <path d="M 340 240 Q 300 260 270 230" stroke="#fecaca" strokeWidth="1" fill="none" strokeDasharray="3 3" markerEnd="url(#arrowhead-red)" data-id="element-332" />
              <path d="M 310 310 Q 330 270 300 240" stroke="#e5e7eb" strokeWidth="1" fill="none" strokeDasharray="4 4" markerEnd="url(#arrowhead)" data-id="element-333" />
              <path d="M 350 350 Q 320 310 280 290" stroke="#fecaca" strokeWidth="0.8" fill="none" strokeDasharray="2 3" markerEnd="url(#arrowhead-red)" data-id="element-334" />
              {/* A couple crossing arrows for extra chaos */}
              <path d="M 250 50 Q 300 100 260 150" stroke="#e5e7eb" strokeWidth="0.8" fill="none" strokeDasharray="3 3" data-id="element-335" />
              <path d="M 340 90 Q 280 130 320 170" stroke="#e5e7eb" strokeWidth="0.8" fill="none" strokeDasharray="2 4" data-id="element-336" />
            </svg>

            {/* Main Content Area */}
            <div className="relative flex-1 w-full h-full" data-id="element-337">
              {/* Center Element — The Missing Destination */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-28 sm:w-36 h-28 sm:h-36 border-2 border-dashed border-red-300 rounded-xl bg-red-50/50 flex flex-col items-center justify-center z-10 p-2" data-id="element-338">
                <HelpCircle className="w-8 h-8 sm:w-10 sm:h-10 text-red-300 mb-2" data-id="element-339" />
                <span className="text-[9px] sm:text-[10px] text-red-400 font-medium text-center leading-tight" data-id="element-340">
                  ¿Dónde va todo esto?
                </span>
              </div>

              {/* Card A: Phone/Photos (Top Left) — expanded 3x3 grid */}
              <div className="absolute top-12 sm:top-14 left-3 sm:left-6 w-28 sm:w-36 bg-white rounded-lg border border-gray-200 shadow-sm p-2 z-20 -rotate-3" data-id="element-341">
                <div className="flex items-center gap-1.5 mb-2" data-id="element-342">
                  <Camera className="w-3.5 h-3.5 text-gray-500" data-id="element-343" />
                  <span className="text-[8px] sm:text-[10px] font-semibold text-gray-700" data-id="element-344">
                    47 fotos
                  </span>
                </div>
                <div className="grid grid-cols-3 gap-0.5 sm:gap-1" data-id="element-345">
                  <div className="aspect-square bg-gray-100 rounded-sm overflow-hidden" data-id="element-346">
                    <img src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=100&h=100&fit=crop" alt="" className="w-full h-full object-cover" data-id="element-347" />
                  </div>
                  <div className="aspect-square bg-gray-100 rounded-sm overflow-hidden" data-id="element-348">
                    <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=100&h=100&fit=crop" alt="" className="w-full h-full object-cover" data-id="element-349" />
                  </div>
                  <div className="aspect-square bg-gray-100 rounded-sm overflow-hidden" data-id="element-350">
                    <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=100&h=100&fit=crop" alt="" className="w-full h-full object-cover" data-id="element-351" />
                  </div>
                  <div className="aspect-square bg-gray-100 rounded-sm overflow-hidden" data-id="element-352">
                    <img src="https://images.unsplash.com/photo-1429497419816-9ca5cfb4571a?w=100&h=100&fit=crop" alt="" className="w-full h-full object-cover" data-id="element-353" />
                  </div>
                  <div className="aspect-square bg-gray-100 rounded-sm overflow-hidden" data-id="element-354">
                    <img src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=100&h=100&fit=crop" alt="" className="w-full h-full object-cover" data-id="element-355" />
                  </div>
                  <div className="aspect-square bg-gray-100 rounded-sm overflow-hidden" data-id="element-356">
                    <img src="https://images.unsplash.com/photo-1565008447742-97f6f38c985c?w=100&h=100&fit=crop" alt="" className="w-full h-full object-cover" data-id="element-357" />
                  </div>
                  <div className="aspect-square bg-gray-100 rounded-sm overflow-hidden" data-id="element-358">
                    <img src="https://images.unsplash.com/photo-1587582423116-ec07293f0395?w=100&h=100&fit=crop" alt="" className="w-full h-full object-cover" data-id="element-359" />
                  </div>
                  <div className="aspect-square bg-gray-100 rounded-sm overflow-hidden" data-id="element-360">
                    <img src="https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=100&h=100&fit=crop" alt="" className="w-full h-full object-cover" data-id="element-361" />
                  </div>
                  <div className="aspect-square bg-gray-100 rounded-sm overflow-hidden" data-id="element-362">
                    <img src="https://images.unsplash.com/photo-1590274853856-f22d5ee3d228?w=100&h=100&fit=crop" alt="" className="w-full h-full object-cover" data-id="element-363" />
                  </div>
                </div>
                {/* Notification Dot */}
                <div className="absolute -top-1.5 -right-1.5 w-3.5 h-3.5 sm:w-4 sm:h-4 bg-red-500 rounded-full border-2 border-white" data-id="element-364" />
              </div>

              {/* Card B: Audio Messages (Top Right) */}
              <div className="absolute top-16 sm:top-20 right-4 sm:right-8 w-24 sm:w-32 bg-white rounded-lg border border-gray-200 shadow-sm p-2 z-20 rotate-2" data-id="element-365">
                <div className="flex items-center gap-1.5 mb-2" data-id="element-366">
                  <Mic className="w-3.5 h-3.5 text-gray-500" data-id="element-367" />
                  <span className="text-[8px] sm:text-[10px] font-semibold text-gray-700" data-id="element-368">
                    12 audios
                  </span>
                </div>
                <div className="space-y-1.5" data-id="element-369">
                  <div className="bg-green-50 rounded-full px-1.5 py-1 flex items-center gap-1 border border-green-100" data-id="element-370">
                    <div className="w-1.5 h-1.5 bg-green-500 rounded-full shrink-0" data-id="element-371" />
                    <div className="flex-1 flex items-center gap-0.5 h-2" data-id="element-372">
                      <div className="w-0.5 h-1 bg-green-400 rounded-full" data-id="element-373" />
                      <div className="w-0.5 h-2 bg-green-400 rounded-full" data-id="element-374" />
                      <div className="w-0.5 h-1.5 bg-green-400 rounded-full" data-id="element-375" />
                      <div className="w-0.5 h-2 bg-green-400 rounded-full" data-id="element-376" />
                      <div className="w-0.5 h-1 bg-green-400 rounded-full" data-id="element-377" />
                    </div>
                  </div>
                  <div className="bg-gray-50 rounded-full px-1.5 py-1 flex items-center gap-1 border border-gray-100" data-id="element-378">
                    <div className="w-1.5 h-1.5 bg-gray-400 rounded-full shrink-0" data-id="element-379" />
                    <div className="flex-1 flex items-center gap-0.5 h-2" data-id="element-380">
                      <div className="w-0.5 h-1.5 bg-gray-300 rounded-full" data-id="element-381" />
                      <div className="w-0.5 h-1 bg-gray-300 rounded-full" data-id="element-382" />
                      <div className="w-0.5 h-2 bg-gray-300 rounded-full" data-id="element-383" />
                    </div>
                  </div>
                </div>
                {/* Notification Dot */}
                <div className="absolute -top-1.5 -right-1.5 w-3.5 h-3.5 sm:w-4 sm:h-4 bg-red-500 rounded-full border-2 border-white" data-id="element-384" />
              </div>

              {/* Card C: Handwritten Notes (Bottom Left) */}
              <div className="absolute bottom-16 sm:bottom-20 left-6 sm:left-10 w-24 sm:w-32 bg-white rounded-lg border border-gray-200 shadow-sm p-2 z-20 rotate-2" data-id="element-385">
                <div className="flex items-center gap-1.5 mb-2" data-id="element-386">
                  <FileText className="w-3.5 h-3.5 text-gray-500" data-id="element-387" />
                  <span className="text-[8px] sm:text-[10px] font-semibold text-gray-700 leading-tight" data-id="element-388">
                    Notas de terreno
                  </span>
                </div>
                <div className="space-y-1.5" data-id="element-389">
                  <div className="h-1.5 w-full bg-gray-200 rounded-full" data-id="element-390" />
                  <div className="h-1.5 w-4/5 bg-amber-200 rounded-full" data-id="element-391" />
                  <div className="h-1.5 w-5/6 bg-gray-200 rounded-full" data-id="element-392" />
                </div>
              </div>

              {/* Card D: Email/WhatsApp (Bottom Right) */}
              <div className="absolute bottom-12 sm:bottom-16 right-6 sm:right-10 w-24 sm:w-32 bg-white rounded-lg border border-gray-200 shadow-sm p-2 z-20 -rotate-2" data-id="element-393">
                <div className="flex items-center gap-1.5 mb-2" data-id="element-394">
                  <MessageSquare className="w-3.5 h-3.5 text-gray-500" data-id="element-395" />
                  <span className="text-[8px] sm:text-[10px] font-semibold text-gray-700" data-id="element-396">
                    Mensajes
                  </span>
                </div>
                <div className="space-y-1.5" data-id="element-397">
                  <div className="bg-gray-100 rounded-md rounded-tl-none p-1.5 w-4/5" data-id="element-398">
                    <div className="h-1 w-full bg-gray-300 rounded-full mb-0.5" data-id="element-399" />
                    <div className="h-1 w-2/3 bg-gray-300 rounded-full" data-id="element-400" />
                  </div>
                  <div className="bg-green-50 rounded-md rounded-tr-none p-1.5 w-4/5 ml-auto border border-green-100" data-id="element-401">
                    <div className="h-1 w-full bg-green-300 rounded-full mb-0.5" data-id="element-402" />
                    <div className="h-1 w-3/4 bg-green-300 rounded-full" data-id="element-403" />
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom Status Bar */}
            <div className="bg-red-50 border-t border-red-100 py-2 sm:py-2.5 px-4 text-center z-30 mt-auto" data-id="element-404">
              <span className="text-[10px] sm:text-xs font-medium text-red-600" data-id="element-405">
                Resultado: 2 horas armando el informe a mano
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}